/*IT'S COMPONENTS FOR SITE_PAGES*/

import Vue from 'vue';

// ** App ** //
Vue.component('app-content', require('./views/App').default);

// ** CATALOG ** //
Vue.component('catalog-card', require('./views/catalog/Card').default);
Vue.component('catalog-filter', require('./views/catalog/Filter').default);
Vue.component('sub-category-nova-card', require('./views/catalog/SubCategoryNovaCard').default);

//** SALE **//

Vue.component('card-sale', require('./views/sale/CardSale').default);

// ** Rules-Navigation ** //
Vue.component('rules-nav-app', require('./views/rules/Navigation').default);

// ** Services-Navigation ** //
Vue.component('services-nav-app', require('./views/services/Navigation').default);

// ** News ** //
Vue.component('news-app', require('./views/news/News').default);
Vue.component('photostudios-app', require('./views/photostudios/Card').default);

// ** BASKET ** //
Vue.component('price-information', require('./views/basket/Price').default);
Vue.component('basket-item', require('./views/basket/Item').default);
Vue.component('order-check-user', require('./views/basket/order/CheckUser').default);
Vue.component('order-details', require('./views/basket/order/OrderDetails').default);
Vue.component('order-products', require('./views/basket/order/Products').default);

Vue.component('calendar-app', require('./views/calendar/Index').default);

//** ACCOUNT **//
Vue.component('account-navigation', require('./views/account/partial/Nav').default);
Vue.component('account-orders', require('./views/account/pages/Orders').default);
Vue.component('account-personal', require('./views/account/pages/Personal').default);
Vue.component('account-ref', require('./views/account/pages/Ref').default);
Vue.component('account-main', require('./views/account/pages/Main').default);
Vue.component('account-card', require('./views/account/pages/Card').default);
Vue.component('account-discount', require('./views/account/pages/Discount').default);
Vue.component('account-item', require('./views/account/partial/Item').default);
Vue.component('account-new', require('./views/account/pages/New').default);
